import React from 'react';
import clsx from 'clsx';
import Icon from '../AppIcon';

const sizeVariants = {
  sm: {
    emblem: 'w-10 h-10',
    ring: 'after:w-[56px] after:h-[56px]',
    text: 'text-lg',
    tagline: 'text-[10px]'
  },
  md: {
    emblem: 'w-12 h-12',
    ring: 'after:w-[70px] after:h-[70px]',
    text: 'text-2xl',
    tagline: 'text-xs'
  },
  lg: {
    emblem: 'w-16 h-16',
    ring: 'after:w-[96px] after:h-[96px]',
    text: 'text-3xl',
    tagline: 'text-sm'
  }
};

const CogitoLogo = ({
  size = 'sm',
  showWordmark = true,
  tagline = 'smart learning',
  interactive = false,
  className = '',
  onClick
}) => {
  const variant = sizeVariants[size] ?? sizeVariants.sm;
  const Wrapper = interactive ? 'button' : 'div';

  return (
    <Wrapper
      type={interactive ? 'button' : undefined}
      onClick={onClick}
      className={clsx('flex items-center space-x-3 focus:outline-none group', className)}
      aria-label={interactive ? 'Cogito home' : undefined}
    >
      <div
        className={clsx(
          'relative shrink-0 rounded-2xl bg-gradient-to-tr from-primary via-primary/80 to-accent shadow-lg ring-1 ring-primary/50 flex items-center justify-center overflow-hidden after:absolute after:rounded-full after:border after:border-primary/30 after:-z-10 after:opacity-0 group-hover:after:opacity-60 transition-all duration-300',
          variant.emblem,
          variant.ring
        )}
      >
        <Icon name="BrainCircuit" size={28} color="white" strokeWidth={1.8} />
        <div className="absolute inset-0 bg-primary/30 mix-blend-overlay opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>

      {showWordmark && (
        <div className="flex flex-col leading-none text-left">
          <span className={clsx('font-semibold tracking-tight text-foreground', variant.text)}>
            Cogito
            <span className="ml-1 text-primary">✦</span>
          </span>
          <span className={clsx('uppercase tracking-[0.25em] text-muted-foreground/80', variant.tagline)}>
            {tagline}
          </span>
        </div>
      )}
    </Wrapper>
  );
};

export default CogitoLogo;
